<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              

             <div class=" col">
                &nbsp;<input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class=" col" >
                &nbsp;<input type="date" class="input" v-model="end_date" />
                
              </div>

              
            </div>
      </div>
        
      </div>
    
   <div class="tabs is-boxed">
        <ul>
            <li v-bind:class="{'is-active': tab === 'results' }" @click="tab='results'"><a>Results</a></li>
           <li v-bind:class="{'is-active': tab === 'orders' }" @click="tab='orders'"><a>Orders</a></li>
           
        </ul>
    </div>

    <div v-if="tab ==='results'">
        <p v-if="orders_loading===true">Loading ...</p>
        <div v-if="orders_loading===false">
            <p>Total Orders Finished by QC In Time Period : <strong>{{ orders.length }}</strong> ( {{ total_order_qty }} garments)</p>
            <br />
            <table class="table is-hoverable is-fullwidth" id="orderstable" >
                <thead>
                    <tr>
                <th width="50%">QC Worker</th>
                <th>Number of Orders</th>
                <th>Total Garments</th>
                
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in users" :key="row.id">
                        <td><span @click="viewUserOrders(row.id)">{{ row.name }}</span></td>
                        <td>{{ row.counter }}</td>
                        <td>{{ row.total_qtys }}</td>
                        </tr>
                </tbody>
                </table>

              <br />
            <table class="table is-hoverable is-fullwidth" id="orderstable" >
                <thead>
                    <tr>
                <th width="50%">Turnaround Days</th>
                <th>Number of Orders</th>
                <th>Total Garments</th>
                
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in days" :key="row.id">
                        <td>{{ row.label }}</td>
                        <td>{{ row.counter }}</td>
                        <td>{{ row.total_qtys }}</td>
                        </tr>
                </tbody>
                </table>
                <em>This is calculated from the date receipted until the day the quality check user marked the job as finished, excluding weekends</em>

        </div>
    </div>

    <div v-if="tab === 'orders'">
        <div class="select is-pulled-right">
            <select  v-model="selected_qc_user_id">
                  <option value="">Filter By User</option>
                  <option v-bind:value="row.id" v-for="row in users" :key="row.id">{{ row.name }}</option>
                  
          </select>
          </div>
        <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
            <thead>
                <tr>
            <th>PO Number</th>
            <th>Customer</th>
            <th>Garment</th>
            <th>Qty</th>
            <th>Design</th>
            <th>Date Finished</th>
            <th>QC User</th>
            <th>Days</th>
            <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="orders_loading===true">
            <td colspan="7"><strong>Loading orders ...</strong></td>
            </tr>
            <tr v-for="(order, index) in filteredOrders" v-bind:key="index" v-show="orders_loading===false">
            <td ><router-link :to="'/digitalprint/view-order?ponumber=' + order.ponumber" target="_blank">{{order.ponumber}}</router-link></td>
            <td>{{order.clientname}}</td>
            <td>{{order.garmentname}}</td>
            <td>{{order.total_qty}}</td>
            <td>{{order.designname}}</td>
            <td>{{order.date}}</td>
            <td>{{ order.firstname }} {{ order.surname }}</td>
            <td>{{order.turnaroundTime}}</td>
            <td>
                <a :href="VUE_APP_ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-info is-small">View</button></a>
            </td>
            
                
                
                </tr>
        </tbody>
        
        </table>

        <button @click="exportXLS()" class="button is-info" style="display:none">Export to Excel</button>
    </div>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import SalesService from '@/services/SalesService.js';
import XLSX from 'xlsx';

export default {
  name:'QCFinishedReport',
  components: {
   	
  },
  data() {
    return {
      client_id: '',
       clients: [],
      orders: [],
       selected_qc_user_id: '',
      username: '',
      start_date: '',
        end_date: '',
      currentSort: 'count',
      currentSortDir: 'desc',
      
     accessToken: '',
     orders_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,
     tab : 'results',
    

     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getQCFinished()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'QC Finished Report.xlsx')

	 },
   
    async getQCFinished() {
      this.orders_loading=true;
      OrderService.getQCFinished(this.accessToken, this.start_date, this.end_date)
          .then(
            (orders => {
              
              this.$set(this, "orders", orders);
              this.orders_loading=false;
            }).bind(this)
          );
    },
    
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 30);
            return d.toISOString().slice(0,10);
             
    },
    viewUserOrders(user_id)
    {
        this.selected_qc_user_id=user_id
        this.tab = 'orders'
    }

   
  },
  computed : {
     total_order_qty() {
        let total = this.orders.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.total_qty;
        }, 0);

        return total;
     },
     users() {
         let filteredUsers = []

         this.orders.forEach(order => {      
            
            let user = filteredUsers.find(user => user.id === order.userID);
            if(user)
            {
                user.counter++
                user.total_qtys += order.total_qty
            }
            else{
                let thisUser = {'id' : order.userID, 'name' : order.firstname + ' ' + order.surname, 'counter' : 1, "total_qtys" : order.total_qty}
                filteredUsers.push(thisUser)
            }
            
        });

         return filteredUsers
     },
     days() {
         let filteredDays = []

         this.orders.forEach(order => {      
            
            let day = filteredDays.find(day => day.label === order.turnaroundTime);
            if(day)
            {
                day.counter++
                day.total_qtys += order.total_qty
            }
            else{
                let thisDay = {'label' : order.turnaroundTime, 'counter' : 1, "total_qtys" : order.total_qty}
                filteredDays.push(thisDay)
            }
            
        });

        filteredDays = filteredDays.sort((c1, c2) => (c1.label > c2.label) ? 1 : (c1.label < c2.label) ? -1 : 0);

         return filteredDays
     },
     filteredOrders: function () {
       let filteredOrders = []

        if(this.selected_qc_user_id != "")
          {
            filteredOrders = this.orders.filter(row => row.user_id === this.selected_qc_user_id)
          }
          else
          {
              filteredOrders = this.orders
          }

          return filteredOrders
       
     },
     
  },

 
  mounted() {
    if (localStorage.qc_finished_start_date) {
      this.start_date = localStorage.qc_finished_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

    if (localStorage.qc_finished_end_date) {
      this.end_date = localStorage.qc_finished_end_date;
    }
    else{
      this.end_date = new Date().toISOString().slice(0,10)
    }

    
    
  },
  watch: {
   
    start_date: function () {
      localStorage.qc_finished_start_date = this.start_date;
      if(this.accessToken != '')
        {
          this.orders = []
          this.getQCFinished()
        }
      
    },
    end_date: function () {
     
      localStorage.qc_finished_end_date = this.end_date;
      if(this.accessToken != '')
        {
          this.orders = []
          this.getQCFinished()
        }
    },
  }
}



</script>


